import React from 'react';
import { Typography } from '../../../_shared/components/Typography/Typography';
import { Card } from '../../../_shared/components/Card/Card';
import styles from './LastActions.module.scss';

export function LastActions({ actions }) {
  return (
    <div className={styles.container}>
      <div className={styles.head}>
        <Typography variant={'h3'}>Последние действия</Typography>
      </div>
      <div className={styles.actions}>
        {actions.map((action, index) => (
          <Card key={index}>
            <div className={styles.activeBlock}>
              <Typography variant={'text'}>
                {action.userName} {action.description}
              </Typography>
              <Typography variant={'text'} className={styles.timeLabel}>
                {action.timeLabel}
              </Typography>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}
